import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { GetGroupsRequest } from '@foxbun/lib-goferal-types';
import { SearchInputWidget } from '../../../widgets/forms/SearchInputWidget';
import { EmptyWidget } from '../../../widgets/content/EmptyWidget';
import { AnimatePageWidget } from '../../../widgets/layout/AnimatePageWidget';
import * as _ from 'lodash';
import { MediaIconWidget } from '../../../widgets/content/MediaIconWidget';
import { AppLink } from '../../../widgets/utils';
import { IconGridLayoutWidget } from '../../../widgets/collection/IconGridLayoutWidget';
import { useBufferedSearch } from '../../../hooks/useBufferedSearch';
import { GroupModel } from '../../../core/models/GroupModel';

export const GroupsPage: React.FC = observer((props) => {
  const system = useSystem();

  const normalizeReq = (req) => {
    return _.pickBy(req, (value) => value != null);
  };

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState<string>(null);
  const [groups, setGroups] = useState<GroupModel[]>([]);
  const [req, setReq] = useState<GetGroupsRequest>({});

  const loadGroups = useCallback(() => {
    setLoading(true);
    system.group_store
      .getGroups(req)
      .then((groups) => {
        setGroups(groups);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [JSON.stringify(req)]);

  useEffect(() => {
    loadGroups();
  }, [JSON.stringify(req)]);

  useBufferedSearch({
    search,
    cb: (search) => {
      setReq(normalizeReq({ search }));
    }
  });

  return (
    <AnimatePageWidget slide={false}>
      <S.Groups>
        <S.Controls>
          <S.Input
            value={search}
            placeholder="search groups names"
            loading={loading}
            onChange={(search) => {
              setSearch(search);
            }}
          />
        </S.Controls>
        {!loading && groups.length === 0 ? <EmptyWidget label="No groups found" /> : null}
        {groups.length > 0 ? (
          <IconGridLayoutWidget<GroupModel>
            gap={10}
            cols={3}
            elements={groups}
            generateElement={(pack) => {
              return (
                <S.LinkWrapper key={pack.key} to={pack.link} push={true}>
                  <S.Media
                    font_size={40}
                    media={{
                      name: pack.data.name,
                      image: pack.image
                    }}
                  />
                </S.LinkWrapper>
              );
            }}
          />
        ) : null}
      </S.Groups>
    </AnimatePageWidget>
  );
});

namespace S {
  export const Input = styled(SearchInputWidget)``;

  export const Controls = styled.div`
    display: flex;
    flex-direction: column;
  `;

  export const Groups = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;

  export const Media = styled(MediaIconWidget)`
    border-radius: 4px;
  `;

  export const LinkWrapper = styled(AppLink)`
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    height: 100%;
  `;
}
